import { type ButtonHTMLAttributes, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import './Button.css'

export type ButtonVariant = 'primary' | 'ghost' | 'outline' | 'danger'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  fullWidth?: boolean
  loading?: boolean
  children: ReactNode
}

export function Button({
  variant = 'primary',
  fullWidth = false,
  loading = false,
  className = '',
  disabled,
  children,
  ...rest
}: Props) {
  const classes = [
    'btn',
    `btn--${variant}`,
    fullWidth && 'btn--full',
    loading && 'btn--loading',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button {...rest} disabled={disabled ?? loading} className={classes}>
      {loading ? <ButtonLoader /> : children}
    </button>
  )
}

// Отдельный компонент: на смену языка подписаны только кнопки в состоянии загрузки.
function ButtonLoader() {
  const { t } = useTranslation()
  return (
    <span className="btn__loader" role="status" aria-label={t(($) => $.common.loadingLabel)}>
      <span className="btn__dot" />
      <span className="btn__dot" />
      <span className="btn__dot" />
    </span>
  )
}
